import { createContext, Dispatch, SetStateAction } from 'react';
import { FocusedMarker, Position } from 'ts/hotel/interfaces/Generic';
import { Hotel } from 'ts/hotel/interfaces/HotelResponse';
import { GeoPolygon } from 'ts/hotel/interfaces/HotelDetails';
import { SerpData } from 'ts/hotel/interfaces/SerpResponse';
import { TripAdvisorData } from 'ts/hotel/interfaces/TripadvisorResponse';

type MapHotelContextValue = {
  centered: Position | undefined;
  focusedHotel: FocusedMarker | undefined;
  setCentered: (_pos: Position | undefined) => void;
  setFocusedHotel: (_post: FocusedMarker) => void;
  initedMap: boolean;
  setInitedMap: (_initted: boolean) => void;
  currency: string;
  setCurrency: (_currency: string) => void;
  activeHotel: Hotel | undefined;
  setActiveHotel: (_hotel?: Hotel) => void;
  pinnedHotelsIds: string[];
  setPinnedHotelsIds: Dispatch<SetStateAction<string[]>>;
  geoPolygons: GeoPolygon[][] | undefined;
  priceMode: string;
  setPriceMode: (_arg: string) => void;
  activeTab: number;
  setActiveTab: (_tab: number) => void;
  gh?: SerpData[];
  setGh?: Dispatch<SetStateAction<SerpData[]>>;
  ta?: TripAdvisorData[];
  setTa?: Dispatch<SetStateAction<TripAdvisorData[]>>;
  areActiveRooms?: boolean;
  setAreActiveRooms?: (_areActiveRooms: boolean) => void;
  resetLocation?: Date;
  setResetLocation?: (_resetLocation: Date) => void;
};

export const MapHotelContext = createContext<MapHotelContextValue>({
  centered: undefined as Position | undefined,
  focusedHotel: undefined as FocusedMarker | undefined,
  setCentered: (_pos: Position | undefined) => {},
  setFocusedHotel: (_post: FocusedMarker) => {},
  initedMap: false,
  setInitedMap: (_initted: boolean) => {},
  currency: 'usd',
  setCurrency: (_currency: string) => {},
  activeHotel: undefined as Hotel | undefined,
  setActiveHotel: (_hotel?: Hotel) => {},
  pinnedHotelsIds: [] as string[],
  setPinnedHotelsIds: ((_ids: SetStateAction<string[]>) => {}) as Dispatch<SetStateAction<string[]>>,
  geoPolygons: undefined as GeoPolygon[][] | undefined,
  priceMode: '0' as string,
  setPriceMode: (_arg: string) => {},
  activeTab: 0,
  setActiveTab: (_tab: number) => {},
  gh: [] as SerpData[],
  setGh: (_gh: SetStateAction<SerpData[]>) => {},
  ta: [] as TripAdvisorData[],
  setTa: (_ta: SetStateAction<TripAdvisorData[]>) => {},
  areActiveRooms: false,
  setAreActiveRooms: (_areActiveRooms: boolean) => {},
  resetLocation: undefined as Date | undefined,
  setResetLocation: (_resetLocation: Date) => {},
});
